import { Document, Page } from 'react-pdf';
import { PDF_DOCUMENT_OPTIONS } from '../../../pdfjsConfig';
import { Box, Stack, Typography } from '@mui/material';
import PinchZoom from '../../../Components/Ui/PinchZoom';
import FileButton from '../ui/FileButton';
import dayjs from 'dayjs';

export default function M_NOT_BASIC_03(props) {
  return (
    <Box sx={{ px: 2 }}>
      <Stack sx={{ display: 'flex', alignItems: 'start', mb: 2, mt: 0 }}>
        <p style={{ fontSize: '18px', fontWeight: 'bold' }}>
          {!props.rowData1?.prefix === 'P'
            ? props.rowData1?.title
            : '안전보건경영방침'}
        </p>
        <div
          style={{
            display: 'flex',
            paddingTop: '8px',
            gap: '8px',
          }}
        >
          <p style={{ fontSize: '14px', color: '#8B8888' }}>
            {props.rowData1?.createId}
          </p>
          <p style={{ fontSize: '14px', color: '#8B8888' }}>
            {dayjs(props.rowData1?.createDate).format('YYYY-MM-DD HH:MM')}
          </p>
        </div>

        <hr
          style={{
            width: '100%',
            borderTop: '2px solid #F8EFEF',
          }}
        />
        {!props.rowData1?.prefix === 'P' && (
          <Box
            sx={{
              fontSize: '17px',
              color: '#333',
              lineHeight: 1.8,
              '& p': { marginBottom: '12px' },
              background: '#fff',
              borderRadius: '12px',
              padding: 1,
            }}
          >
            {props.rowData1?.comment}
          </Box>
        )}
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{ width: '100%' }}
      >
        {props.fileInfo && props.fileInfo.url ? (
          <>
            <PinchZoom
              contents={
                props.fileInfo.ext === 'pdf' || props.fileInfo.ext === 'hwp' ? (
                  <Document
                    file={props.fileInfo.url}
                    options={PDF_DOCUMENT_OPTIONS}
                    onLoadSuccess={props.onDocumentLoadSuccess}
                  >
                    <Page
                      pageNumber={props.pageNumber}
                      width={props.pageWidth}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </Document>
                ) : (
                  <img
                    src={props.fileInfo.url}
                    alt="미리보기"
                    style={{ width: props.pageWidth, objectFit: 'contain' }}
                  />
                )
              }
            />
            <FileButton
              onCancel={props.goToPrevPage}
              onClick={props.goToNextPage}
              pageNumber={props.pageNumber}
              numPages={props.numPages}
              disabledNext={props.isLastPost && props.isLastPage}
            />
          </>
        ) : (
          <Typography sx={{ color: '#ff0000' }}>
            파일 정보가 없습니다.
          </Typography>
        )}
      </Box>
    </Box>
  );
}
